import { Validation } from "./Validation";

/**
 * Anhang einer Newsletter Ausssendung. 
 */
export default interface MailingMessageAttachmentJson {
    ID: number | null,

    /**
     * Dateinname des Anhangs.
     */
    fileName: string,

    /**
     * Dateiinhalt des Anhangs als base 64. Ist immer null um Bandbreite zu sparen, außer der Anhang wird explizit abgerufen.
     */
    data: string | null;
}

export function validateMailingMessageAttachmentJson(item: MailingMessageAttachmentJson) {
    return new Validation(item)
        .validateInteger("ID", 0, null, false)
        .validateNonEmptyString("fileName", 100)
        .finish();
}
export function validateMailingMessageAttachmentJsonNew(item: MailingMessageAttachmentJson) {
    return new Validation(item)
        .validateEquals("ID", null)
        .validateNonEmptyString("fileName", 100)
        .finish();
}